<template>
  <div id="add-category-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">ADD CATEGORY</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <vue-spinner v-if="loading"></vue-spinner>
              <div v-else class="form-group" :class="{ 'has-error': errors.has('add-category.title') }">
                <input class="form-control" type="text" autocomplete="off" placeholder="Title" name="title" v-model="title" v-validate="'required'">
                <span v-show="errors.has('add-category.title')" class="help-block">{{ errors.first('add-category.title') }}</span>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :disabled="loading" class="btn green" @click.prevent="addCategory">Add</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from "@/components/Spinner";
  import {HTTP, ERROR} from '@/http-common';

  export default {
    name: 'AddCategoryModal',
    components: {
      VueSpinner : Spinner
    },
    data() {
      return {
        loading: false,
        title: ''
      }
    },
    mounted() {
      $('#add-category-modal').modal('show');
      $('#add-category-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    inject: {
      $validator: '$validator'
    },
    methods: {
      addCategory() {
        this.loading = true;
        HTTP.post('/tutorials/add-category', {
          title: this.title
        }).then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.loading = false;
              this.$emit('category-added', response.data.data.id);
              this.$emit('display', false);
              $('#add-category-modal').modal('hide');
            }
          })
          .catch(err => {
            this.$notify({
              type: 'error',
              text: 'Something went wrong while trying to add category.'
            });
            $('#add-category-modal').modal('hide');
            this.$emit('display', false);
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddCategoryModal.vue?7e2485c7